import cmake from "refractor/cmake";
export default cmake;